import { createActions } from 'redux-actions';
import ActionTypes from '../constants/ActionTypes';

export default createActions(
  {},
  `${ActionTypes.NEW_UTM_SOURCE}`,
  `${ActionTypes.CLEAR_UTM_SOURCE}`,
);
